import { render } from "./ConfirmView.vue?vue&type=template&id=c56c9706&scoped=true"
import script from "./ConfirmView.vue?vue&type=script&lang=js"
export * from "./ConfirmView.vue?vue&type=script&lang=js"

import "./ConfirmView.vue?vue&type=style&index=0&id=c56c9706&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c56c9706"]])

export default __exports__